import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { PaymentGatewayService } from '../payment-gateway-service';
import { environment } from 'src/environments/environment';

interface Merchant {
    emailId: string;
    payId: string;
    businessName: string;
    currency?: string;
    paymentType?: string;
    mop?: string;
    transactionType?: string;
    acquirer?: string;
    region?: string;
    type?: string;
    selected?: boolean;

}

interface RouterRule {
    id: number;
    currency: string;
    paymentType: string;
    mopType: string;
    transactionType: string;
    status: string;
    onUsFlag: boolean;
    createdDate: string;
    updatedDate: string | null;
    merchant: string;
    requestedBy: string;
    approvedBy: string;
    paymentsRegion: string;
    cardHolderType: string;
    payId: string;
    acquirerMap: string;
    selected?: boolean;
}

@Component({
  selector: 'app-rule-engine',
  templateUrl: './rule-engine.component.html',
  styleUrls: ['./rule-engine.component.scss']
})
export class RuleEngineComponent implements OnInit {

 activeTab: string = 'second';
    selectedMerchant: string | null = null;
    selectedMerchantbydefault: string | null = null;
    selectedSecondOption: string = 'ALL';
    selectedFirstOption: string | undefined;
    selectedAcquirer: string | undefined;
    selectedAcquirer2: string | undefined;
    selectedPaymentType: string | undefined;
    selectedPaymentType2: string | undefined;
    selectedMopType: string | undefined;
    selectedTransactionType: string | undefined;
    selectedRegionType: string | undefined;
    selectedType: string | undefined;
    merchantName: string = '';
    merchantName2: string = '';
    selectedMerchantChecked: boolean = false;
    merchants: Array<Merchant> = [];
    merchantData: Array<Merchant> = [];
    routerRules: Array<RouterRule> = [];
    acquirers: string[] = [];
    paymentTypes: string[] = [];
    mopTypes: string[] = [];
    selectedMopTypes: { [key: string]: boolean } = {};
    selectedCurrency2: string | undefined;
    currencies: string[] = [];
    isEditing: boolean = false;
    selectedRule: any = null;
    selectedRules: any = {
        acquirers: [], // Start with an empty array
    };

    allAcquirers: string[] = [];

    isAcquirer: boolean = false;





    constructor(private alertService: AlertService, private cd: ChangeDetectorRef, private _TRS: PaymentGatewayService) { }


    currencyMap: { [key: string]: string } = {
        'AED': '784',
        'AUD': '036',
        'CAD': '124',
        'EUR': '978',
        'GBP': '826',
        'INR': '356',
        'USD': '840',
    };


    ngOnInit(): void {
        this.getAllMerchants();
    }

    toggleSelectAll(event: any): void {
        const isChecked = event.target.checked;
        this.routerRules.forEach(rule => {
            rule.selected = isChecked;
        });
    }


    getAllMerchants() {
        this._TRS.getAllMerchants().subscribe({
            next: (data: any) => {
                this.merchants = data && data.length ? data : [];
                // this.logger.log(`Fetched merchants: ${JSON.stringify(this.merchants)}`);
                if (this.merchants.length) {
                    this.selectedMerchantbydefault = this.merchants[0].payId;
                    this.fetchAcquirersForMerchant(this.merchants[0].payId);
                }
            },
            error: err => {
                // this.logger.error(`Error fetching merchants: ${err?.Message || 'Unknown error'}`);
                this.alertService.toastErrorMessageAlert({ title: err?.Message || 'Something went wrong!' });
            }
        });
    }

    deleteSelected(): void {
        const loggedUserEmailId = environment.adminUser;
        const selectedRules = this.routerRules.filter(rule => rule.selected);

        if (selectedRules.length === 0) {
            this.alertService.toastErrorMessageAlert({ title: 'No rules selected for deletion!' });
            return;
        }
        if (!loggedUserEmailId) {
            alert('User email is not found. Please log in again.');
            return;
        }

        const ids = selectedRules.map(rule => rule.id);
        const payload = {
            ids: ids,
            loggedUserEmailId: loggedUserEmailId
        };

        // Call the delete API
        this._TRS.deleteRules(payload).subscribe({
            next: response => {
                this.routerRules = this.routerRules.filter(rule => !rule.selected);
                this.alertService.toastSuccessMessageAlert({ title: 'Selected rules deleted successfully!' });
                console.log('Deletion response:', response);
            },
            error: err => {
                this.alertService.toastErrorMessageAlert({ title: err?.Message || 'Failed to delete rules!' });
                console.error('Deletion error:', err);
            }
        });
    }

    onMerchantSelect(selectedPayId: string) {
        this.fetchRouterRules(selectedPayId);
        this.activeTab = 'first';
    }

    fetchRouterRules(payId: string) {
        this._TRS.getRuleLists(payId).subscribe({
            next: (data: any) => {
                if (data?.payload?.routerRules) {
                    this.routerRules = data.payload.routerRules.map((rule: RouterRule) => ({
                        ...rule,
                        selected: false
                    })) as Array<RouterRule>;

                    // this.logger.log(`Fetched router rules for ${payId}: ${JSON.stringify(this.routerRules)}`);
                } else {
                    this.routerRules = [];
                    // this.logger.info(`No router rules found for ${payId}`);
                }
                this.cd.markForCheck();
            },
            error: err => {
                console.error('Error fetching merchant data:', err);
                // this.logger.error(`Error fetching data for merchant ${payId}: ${err?.Message || 'Unknown error'}`);
                this.alertService.toastErrorMessageAlert({ title: err?.Message || 'Failed to fetch merchant data!' });
            }
        });
    }


    handleMerchantSelection(selectedPayId: string) {
        this.selectedMerchantbydefault = selectedPayId;
        this.selectedCurrency2 = undefined;
        this.selectedAcquirer2 = undefined;
        this.selectedPaymentType2 = undefined;
        this.selectedMopType = undefined;
        this.selectedTransactionTypes = { AUTHORISE: false, SALE: false };
        this.selectedRegionType = '';
        this.selectedType = '';
        this.paymentTypes = [];
        this.mopTypes = [];
        this.currencies = [];
        this.isAcquirer = false;
        Object.keys(this.selectedMopTypes).forEach((mopType) => {
            this.selectedMopTypes[mopType] = false;
        });
        this.fetchAcquirersForMerchant(selectedPayId);
        this.activeTab = 'second';
    }

    fetchAcquirersForMerchant(payId: string) {
        this._TRS.getAcquirer(payId).subscribe({
            next: (data: any) => {
                if (data?.payload?.acquirerList) {
                    this.acquirers = data.payload.acquirerList;
                    this.currencies = Object.values(data.payload.currencyMap);
                    // console.log("currencies : ",this.currencies);
                    // this.logger.log(`Fetched acquirers for ${payId}: ${JSON.stringify(this.acquirers)}`);
                } else {
                    this.acquirers = [];
                    // this.logger.info(`No acquirers found for ${payId}`);
                }
            },
            error: err => {
                console.error('Error fetching acquirers:', err);
                // this.logger.error(`Error fetching acquirers for merchant ${payId}: ${err?.Message || 'Unknown error'}`);
                this.alertService.toastErrorMessageAlert({ title: err?.Message || 'Failed to fetch acquirers!' });
            }
        });
    }

    toggleTab(tab: string) {
        this.activeTab = this.activeTab === tab ? '' : tab;
    }

    get filteredMerchants() {
        return this.merchants.filter(merchant => merchant.payId === this.selectedMerchant);
    }

    onRemove(rule: any): void {
        const loggedUserEmailId = environment.adminUser;
        if (!rule.selected) {
            alert('Please select the checkbox before editing.');
            return;
        }

        if (!loggedUserEmailId) {
            alert('User email is not found. Please log in again.');
            return;
        }
        console.log('Remove clicked for:', rule);

        this._TRS.deleteRule(rule.id, loggedUserEmailId).subscribe({
            next: response => {
                this.routerRules = this.routerRules.filter(r => r.id !== rule.id);
                this.alertService.toastSuccessMessageAlert({ title: 'Rule removed successfully!' });
                console.log('Removal response:', response);
            },
            error: err => {
                this.alertService.toastErrorMessageAlert({ title: err?.Message || 'Failed to remove rule!' });
                console.error('Removal error:', err);
            }
        });
    }

    handleAcquirerSelection(acquirerName: string) {
        console.log("acquirer name for paymentType:", acquirerName);
        this.selectedAcquirer2 = acquirerName;
        this.fetchPaymentTypes();

    }


    // off us
    getCurrencies() {
        const merchantId = this.selectedMerchantbydefault ?? '';
        const acquirer = this.selectedAcquirer2 ?? '';
        if (merchantId && acquirer) {
            const payload = {
                merchantId: merchantId,
                acquirer: acquirer,
            };
            this._TRS.fetchCurrencies(payload).subscribe({
                next: (response: any) => {
                    if (response?.payload?.currencyMap) {
                        this.currencies = Object.values(response.payload.currencyMap);
                        console.log(`Fetched  currencies: ${JSON.stringify(this.currencies)}`);
                    } else {
                        console.warn('No payment types returned or paymentTypes is not an array');
                        this.currencies = [];
                    }
                },
                error: err => {
                    console.error('Error fetching currencies:', err);
                }
            });
        } else {
            console.error('Merchant ID or Acquirer is not valid');
        }
    }
    selectedCurrencies: string[] = [];
    handleCurrencySelection(selectedCurrency: any, event: any) {
        // Check if the checkbox is checked or unchecked
        const isChecked = event.target.checked;

        if (isChecked) {
            // If checked, add to selected currencies
            if (!this.selectedCurrencies.includes(selectedCurrency)) {
                this.selectedCurrencies.push(selectedCurrency);
            }
        } else {
            // If unchecked, remove from selected currencies
            const index = this.selectedCurrencies.indexOf(selectedCurrency);
            if (index > -1) {
                this.selectedCurrencies.splice(index, 1);
                this.selectedAcquirer2 = "";
                this.selectedPaymentType2 = "";
                Object.keys(this.selectedMopTypes).forEach((mopType) => {
                    this.selectedMopTypes[mopType] = false;
                });
            }
        }

        // Log the current selected currencies
        console.log(`Selected currencies: ${this.selectedCurrencies.join(', ')}`);

        // Determine if there are any selected currencies and update isAcquirer
        if (this.selectedCurrencies.length > 0) {
            this.isAcquirer = true;
        } else {
            this.isAcquirer = false;
        }

        // You can use the currency map here if needed
        // const numericValue = this.currencyMap[selectedCurrency];
        // console.log(`Numeric value: ${numericValue}`);
    }



    fetchPaymentTypes() {
        if (!this.selectedMerchantbydefault || !this.selectedAcquirer2) return;
        const selectedCurrencyNumeric = this.selectedCurrency2 ? this.currencyMap[this.selectedCurrency2] : undefined;

        const requestBody = {
            merchantId: this.selectedMerchantbydefault,
            currencies: selectedCurrencyNumeric ? [selectedCurrencyNumeric] : [],
            acquirer: this.selectedAcquirer2,
            // selectedCurrency: 
        };
        console.log(JSON.stringify(requestBody))
        this._TRS.getPaymentTypes(requestBody).subscribe({
            next: (response: any) => {
                if (response?.payload?.acquirerList1) {
                    this.paymentTypes = response.payload.acquirerList1;
                    console.log(`Fetched payment types: ${JSON.stringify(this.paymentTypes)}`);
                } else {
                    console.warn('No payment types returned or paymentTypes is not an array');
                    this.paymentTypes = [];
                }
            },
            error: err => {
                console.error(`Error fetching payment types: ${err?.Message || 'Unknown error'}`);
                this.alertService.toastErrorMessageAlert({ title: err?.Message || 'Failed to fetch payment types!' });
            }
        });
    }


    handlePaymentTypeSelection(paymentType: string) {
        this.selectedPaymentType2 = paymentType;
        this.fetchMopTypes();
    }

    fetchMopTypes() {
        if (!this.selectedMerchantbydefault || !this.selectedAcquirer2 || !this.selectedPaymentType2) return;

        //  const selectedCurrencyValue = this.selectedCurrencies ? this.currencyMap[this.selectedCurrency2] : undefined;

        // Check if selectedCurrencyValue is defined
        if (!this.selectedCurrencies) {
            console.error('Selected currency is not defined');
            this.alertService.toastErrorMessageAlert({ title: 'Please select a currency before proceeding!' });
            return;
        }

        const payload = {
            payId: this.selectedMerchantbydefault,
            acquirer: this.selectedAcquirer2,
            // selectedCurrency: this.selectedCurrencies.map(currency => `"${currency}"`).join(','),
            // selectedCurrency: "356",
            selectedCurrency: "784",

            paytype: this.selectedPaymentType2,
        };
        this._TRS.getMopTypes(payload).subscribe({
            next: (response: any) => {
                if (response?.payload?.acquirerList2) {
                    this.mopTypes = response.payload.acquirerList2;
                    console.log(`Fetched mop types: ${JSON.stringify(this.mopTypes)}`);
                } else {
                    console.warn('No mop types returned');
                    this.mopTypes = [];
                }
            },
            error: err => {
                console.error(`Error fetching mop types: ${err?.Message || 'Unknown error'}`);
                this.alertService.toastErrorMessageAlert({ title: err?.Message || 'Failed to fetch mop types!' });
            }
        });
    }



    onSave() {
        // Validate that a merchant is selected
        if (!this.selectedMerchantbydefault) {
            this.alertService.toastErrorMessageAlert({ title: 'Please select a merchant before saving!' });
            return;
        }
        // Validate that a currency is selected
        if (!this.selectedCurrencies) {
            this.alertService.toastErrorMessageAlert({ title: 'Please select a currency before saving!' });
            return;
        }

        const selectedMopTypesArray = Object.keys(this.selectedMopTypes).filter(key => this.selectedMopTypes[key]);

        // Check if at least one mop type is selected
        if (selectedMopTypesArray.length === 0) {
            this.alertService.toastErrorMessageAlert({ title: 'Please select at least one mop type before saving!' });
            return;
        }

        // Validate other required fields
        const validations = [
            { condition: !this.selectedAcquirer2, message: 'Please select an acquirer before saving!' },
            { condition: !this.selectedPaymentType2, message: 'Please select a payment type before saving!' },
            { condition: !Object.values(this.selectedTransactionTypes).some(value => value), message: 'Please select at least one transaction type before saving!' },
            { condition: !this.selectedRegionType, message: 'Please select a region type before saving!' },
            { condition: !this.selectedType, message: 'Please select a type before saving!' },
        ];

        for (const { condition, message } of validations) {
            if (condition) {
                this.alertService.toastErrorMessageAlert({ title: message });
                return;
            }
        }

        const loggedUserEmailId = environment.adminUser;
        const acquirerIndex = 1;

        // Prepare the data to be sent to the API
        const payload = {
            listData: [
                {
                    merchant: this.selectedMerchantbydefault,
                    // currency: this.selectedCurrencies.map(currency => `"${currency}"`).join(','),
                    // currency: "INR",
                    currency: "AED",
                    paymentType: this.selectedPaymentType2,
                    mopType: selectedMopTypesArray[0],
                    transactionType: Object.keys(this.selectedTransactionTypes).find(type => this.selectedTransactionTypes[type]),
                    acquirerMap: `${acquirerIndex}-${this.selectedAcquirer2}`,
                    onUsFlag: false,
                    payId: this.selectedMerchantbydefault,
                    cardHolderType: this.selectedType,
                    paymentsRegion: this.selectedRegionType
                }
            ],
            num: "1",
            loggedUserEmailId: loggedUserEmailId
        };

        this._TRS.saveOffusData(payload).subscribe({
            next: (response:any) => {
                // Check for failure in the response
                if (response.status == "OK") {
                    this.alertService.toastSuccessMessageAlert({ title: response.message || 'Data saved successfully!' });
                    this.offReset();
                } else {
                    this.alertService.toastWarringMessageAlert({ title: response.message || 'Something Went Wrong!' });
                }
            },
            error: err => {
                const errorMessage = err?.message || 'Failed to save data!';
                this.alertService.toastErrorMessageAlert({ title: errorMessage });
                console.error('Error saving data:', err);
            }

        });
    }


    onReset() {
        this.selectedCurrency2 = undefined;
        this.selectedAcquirer2 = '';
        this.selectedPaymentType2 = '';
        this.selectedMopType = undefined;
        this.selectedTransactionTypes = { AUTHORISE: false, SALE: false };
        this.selectedRegionType = '';
        this.selectedType = '';
        this.activeTab = 'first';
    }

    offReset() {
        this.selectedCurrency2 = undefined;
        this.selectedAcquirer2 = '';
        this.selectedPaymentType2 = '';
        this.selectedMopType = undefined;
        this.selectedTransactionTypes = { AUTHORISE: false, SALE: false };
        this.selectedRegionType = '';
        this.selectedType = '';
        this.activeTab = 'second';
        this.isEditing = false;
        this.selectedRules.acquirers = [];
        this.selectedMerchant = null;
    }
    selectedTransactionTypes: { [key: string]: boolean } = {
        AUTHORISE: false,
        SALE: false,
    };

    onEdit(rule: any) {
        if (!rule.selected) {
            alert('Please select the checkbox before editing.');
            return;
        }

        this.selectedRule = { ...rule };
        this.isEditing = true;

        // Call the service to get acquirers based on the payId
        this._TRS.getAcquirer(rule.payId).subscribe({
            next: (data: any) => {
                if (data?.payload?.acquirerList) {
                    this.acquirers = data.payload.acquirerList;
                    this.allAcquirers = [...this.acquirers];
                    // this.logger.log(`Fetched acquirers for ${rule.payId}: ${JSON.stringify(this.acquirers)}`);
                } else {
                    this.acquirers = [];
                    this.allAcquirers = [];
                    // this.logger.info(`No acquirers found for ${rule.payId}`);
                }

                const selectedAcquirers = rule.acquirerMap.split(',').map((name: string) => name.trim());
                this.selectedRule.primaryAcquirer = selectedAcquirers[0];
                this.selectedRule.additionalAcquirers = selectedAcquirers.slice(1);
                this.selectedRules.acquirers = [];
                this.selectedRules.acquirers.push('');
            },
            error: (err) => {
                // this.logger.error(`Error fetching acquirers for ${rule.payId}: ${err}`);
            }
        });
    }


    onUpdate() {
        const loggedUserEmailId = environment.adminUser;
        const acquirersString = this.getSelectedAcquirersString();
        if (this.selectedRules.acquirers[this.selectedRules.acquirers.length - 1]) {
            const payload = {
                listData: [
                    {
                        id: this.selectedRule.id,
                        merchant: this.selectedRule.merchant,
                        // currency: this.currencyMap[this.selectedRule.currency],
                        // currency: "INR",
                        currency: "AED",
                        paymentType: this.selectedRule.paymentType,
                        mopType: this.selectedRule.mopType,
                        transactionType: this.selectedRule.transactionType,
                        // acquirerMap: this.selectedRule.firstAcquirer,
                        acquirerMap: acquirersString,
                        onUsFlag: this.selectedRule.onUsFlag,
                        payId: this.selectedRule.payId,
                        cardHolderType: this.selectedRule.cardHolderType,
                        paymentsRegion: this.selectedRule.paymentsRegion,
                    }
                ],
                loggedUserEmailId: loggedUserEmailId
            };
            this._TRS.updateRules(payload).subscribe({
                next: (response:any) => {
                    if (response.messageStatus === "FAILURE") {
                        console.error('Server response indicates failure:', response);
                        this.alertService.toastErrorMessageAlert({ title: response.message || 'An error occurred!' });
                        return;
                    }
                    this.alertService.toastSuccessMessageAlert({ title: 'Data updated successfully!' });
                    console.log('Response from update API:', response);
                    this.offReset();
                },
                error: err => {
                    console.error('Error response:', JSON.stringify(err, null, 2));
                    const errorMessage = err?.message || 'Failed to save data!';
                    this.alertService.toastErrorMessageAlert({ title: errorMessage });
                }
            });
            this.onReset();
            this.activeTab = 'first';
        } else {
            this.alertService.toastWarringMessageAlert({ title: "Choose Acquirer", html: 'Please Choose Acquirer Preferenses or remove unused Preferenses!' });
        }
    }

    onCancel() {
        this.isEditing = false;
        this.selectedRule = null;
        this.activeTab = 'first';
    }
    // formatAcquirers(acquirerMap: string): string {
    //     return acquirerMap;
    // }

    getFormattedAcquirerMap(acquirerMap: string): string {
        const acquirerArray = acquirerMap.split(',').map(acquirer => acquirer.trim());
        const uniqueAcquirers = new Set<string>();
        acquirerArray.forEach(acquirer => {
            const parts = acquirer.split('-');
            if (parts.length === 2) {
                uniqueAcquirers.add(parts[1].trim());
            } else {
                uniqueAcquirers.add(acquirer.trim());
            }
        });
        return Array.from(uniqueAcquirers)
            .map((acquirer, index) => `${index + 1}-${acquirer}`)
            .join(', ');
    }


    getRemainingAcquirers(index: number): string[] {
        const selectedAcquirers = this.selectedRules.acquirers.slice();
        if (selectedAcquirers[index]) {
            selectedAcquirers.splice(index, 1);
        }
        return this.allAcquirers.filter(acquirer => !selectedAcquirers.includes(acquirer));
    }


    addAcquirer() {
        const selectedAcquirers = this.selectedRules.acquirers.slice();
        let remainingArr = this.allAcquirers.filter(acquirer => !selectedAcquirers.includes(acquirer));
        if (remainingArr.length) {
            if (!this.selectedRules.acquirers.includes('')) {
                this.selectedRules.acquirers.push('');
            }
        }
    }
    removeAcquirer(index: number) {
        this.selectedRules.acquirers.splice(index, 1);
    }

    getSelectedAcquirersString(): string {
        let result1 = this.selectedRules.acquirers.slice()
            .map((item: string, index: number) => item ? `${index + 1}-${item}` : item)
            .join(',');
        let arr1 = this.selectedRule.acquirerMap.split(',');
        let arr2 = result1.split(',');
        let combined = arr1.concat(arr2.filter((item: any) => item !== ''));
        let unique = new Set<string>();
        let result2 = combined.filter((item: any) => {
            let value = item.split('-')[1];
            if (!unique.has(value)) {
                unique.add(value);
                return true;
            }
            return false;
        });
        let countMap: { [key: string]: number } = {};
        result2.forEach((item: any) => {
            countMap[item] = (countMap[item] || 0) + 1;
        });
        let result = Object.entries(countMap)
        .map(([key, count], index) => `${index + 1}-${key.split('-')[1]}`)
        .join(',');
        return result;
    }

}
